import { render } from "./_icon-loading.vue?vue&type=template&id=25e20f5c"
import script from "./_icon-loading.vue?vue&type=script&lang=js"
export * from "./_icon-loading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__